import { render, staticRenderFns } from "./RequestView.vue?vue&type=template&id=3b71a3be&"
import script from "./RequestView.vue?vue&type=script&lang=ts&"
export * from "./RequestView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports